<script setup lang="ts">
import BaseNotification from "#core/features/notifications/components/BaseNotification.vue";
import {NuxtLink} from "#components";
const props = defineProps({
  psychologist: {
    type: String,
    required: true,
  }
})
const {catalogItem, fetchCatalogItem} = useCatalog();
const localePath = useLocalePath();

const route = useRoute();

const checkoutRoute = computed(() => {
  if (route.name.indexOf('cabinet-customer') !== -1) {
    return `/cabinet/customer/catalog/${props.psychologist}/checkout`;
  } else if (route.name.indexOf('cabinet-employee') !== -1) {
    return `/cabinet/employee/catalog/${props.psychologist}/checkout`;
  } else {
    return `/psychologists/checkout/${props.psychologist}`;
  }
})

onBeforeMount(() => {
  fetchCatalogItem(props.psychologist);
})
</script>

<template>
  <BaseNotification v-show="catalogItem" :image="catalogItem?.thumbnailUrl">
    <template #title>{{ $t('notificationsStatusBar.checkout.title') }}</template>

    <template #content>
      <p>{{ $t('notificationsStatusBar.checkout.message') }}<strong>{{ catalogItem?.name }}</strong></p>
      <div class="mt-4">
        <MosaicUiButtonsPrimaryButton
          :tag="NuxtLink"
          :to="localePath(checkoutRoute)"
          size="small"
        >
          {{ $t('notificationsStatusBar.checkout.button') }}
        </MosaicUiButtonsPrimaryButton>
      </div>
    </template>
  </BaseNotification>
</template>

<style scoped>

</style>